﻿import common = require("../../../common");
import Vue from "vue";
import Component from "vue-class-component";
import VueSelect from "vue-select";
import HotEditableFormManager = require("./HotEditableFormManager");
import utilities = require("../../utilities");
import context = require("../../context");
import HotEditableHelpers = require("./HotEditableHelpers");

// Fonction éxécutée pour obtenir le template du contrôle (définie dans _HotEditableSelectVueComponent.cshtml)
declare function __getHotEditableMultiSelectComponentTemplate(): string;

@Component({
    props: {
        // Props (attributs sur le tag HTML initial) (les props sont préfixées par 'init' dans prepareMarkup())
        initId: String,
        initName: String,
        initClass: String,
        initValue: String,
        initTabIndex: Number,
        initDisplayName: String,
        initRequired: String,
        initDefaultValue: String,
        initPlaceholder: String,
        initEditModeOn: Boolean,
        initCanChangeEditMode: Boolean,
        initOptions: Array,
        initClearable: Boolean,
        initIsMultiselections: Boolean
    }
})
/**
 * 
 */
class HotEditableMultiSelectComponent extends Vue
    implements common.IHotEditableFieldComponent {
    // Props définies plus haut (pour compatibilité TypeScript)
    initId: string;
    initName: string;
    initClass: string;
    initValue: string;
    initDefaultValue: string;
    initTabIndex: number;
    initDisplayName: string;
    initRequired: string;
    initEditModeOn: boolean;
    initCanChangeEditMode: boolean;
    initOptions: any[];
    initPlaceholder: string;
    initClearable: boolean;

    rootId: string;
    idElement: string;
    elementName: string;
    cssClass: string;
    defaultValue: string; //Valeur affiché en mode lecture (label) quand aucune valeur de sélectionnée.
    tabIndex: number;
    required: boolean;
    displayName?: string; //Champ utilisé pour identifier le champ lors des messages aux utilisateurs.
    editModeOn: boolean;
    placeholder: string; //Message affiché quand le champ n'a pas de sélection en mode edition.
    canChangeEditMode: boolean;
    clearable: boolean;
    options: common.IHotEditableSelectOption[];
    fieldType = common.HotEditableFieldTypes.select;
    elementValue: common.IHotEditableSelectOption[];
    _elementValue: common.IHotEditableSelectOption[];
    hasError: boolean;

    _previousValue = null as any;
    // Privates props (doivent etre expose en public pour que ces props soient transferees dans le VueClassComponent)
    _formManagerParent: HotEditableFormManager;//NOTE: Doit undefined initialement car il est definie dans le "beforeCreate"
    //_disableNextChangedAction = false; //NOTE: Previens le double-changed en provenance du input::blur()

    static tagName = "hoteditablemultiselect";
    static prepareMarkup(element: HTMLSelectElement) {

        if (!element)
            throw "[" + this.tagName + "::prepareMarkup] L'element est NULL";

        element.removeAttribute("hot-editable");
        element.setAttribute("hot-editable-cloak", "");

        const optionElements = element.options;
        const originalOuterHtml = element.outerHTML;

        const selectedValues = [] as string[];
        var optionsJson = "[";
        if (optionElements) {
            for (let i = 0; i < optionElements.length; i++) {
                const o = optionElements[i];

                if (i)
                    optionsJson += ",";

                optionsJson += "{ label: '{label}', code: '{code}' }"
                    .replace("{label}", utilities.escapeSimpleQuote(o.text))
                    .replace("{code}", utilities.escapeSimpleQuote(o.value));

                //if (element.selectedIndex === i)
                if (o.hasAttribute('selected'))
                    selectedValues.push(o.value);
            }

            const nbOptions = optionElements.length;

            for (let j = 0; j < nbOptions; j++)
                element.remove(0);
        }
        optionsJson += "]";

        // element = (() => {
        //     const name = element.name;
        //     const all = document.getElementsByName(name);
        //     if (all.length > 1)
        //         throw "Plusieurs champs posede le meme attribute 'name' (valeur = " + name + ").";
        //     return all[0] as HTMLSelectElement;
        // })();

        const hasValue =
            element.outerHTML.indexOf(" value=") > 0 ||
            element.outerHTML.indexOf(" init-value=") > 0;
        const value = hasValue ? "" : ' init-value="{0}" '.replace("{0}", selectedValues.join(HotEditableMultiSelectComponent.getTextSubValueDelimiter()));
        const options = ' v-bind:init-options="{a}"{b}'
            .replace("{a}", optionsJson)
            .replace("{b}", value);

        const newOuterHtml = originalOuterHtml
            .replace(" id=", " init-id=")
            .replace(" name=", " init-name=")
            .replace(" value=", "init-value=")
            .replace(" class=", " init-class=")
            .replace(" default-value=", " init-default-value=")
            .replace(" tabindex=", " v-bind:init-tab-index=")
            .replace(" required=", " init-required=")
            .replace(" display-name=", " init-display-name=")
            .replace(" placeholder=", " init-placeholder=")
            .replace(" clearable=", " v-bind:init-clearable=")
            .replace(" multiselect=", " v-bind:init-is-multiselections=")
            .replace(" edit-mode-on=", " v-bind:init-edit-mode-on=")
            .replace(" can-change-edit-mode=", " v-bind:init-can-change-edit-mode=")
            .replace("<select ", "<" + this.tagName + ' ' + options + ' ')
            .replace("</select", "</" + this.tagName);

        element.outerHTML = newOuterHtml;
    }

    private static getTextSubValueDelimiter() {
        return context.url.delimiters.subValueDelimiter;
    }

    data() {
        const guid = utilities.createGuid('N');
        const id = this.initId || "Field_" + guid;
        const value = this.textualValueToOptions(this.initValue, this.initOptions);
        const o = {
            rootId: "HotEditableField_" + guid,
            idElement: id,
            elementName: this.initName || id,
            cssClass: this.initClass || "",
            options: this.initOptions || [],
            defaultValue: this.initDefaultValue || "",
            tabIndex: this.initTabIndex,
            required: this.initRequired === "required",
            displayName: this.initDisplayName || null,
            placeholder: this.initPlaceholder || "",
            editModeOn: this.initEditModeOn === true,
            canChangeEditMode: this.initCanChangeEditMode === true,
            clearable: this.initClearable === true,
            hasError: false,
            elementValue: value,
            _elementValue: value
        };

        return o;
    }
    // Fonction système exécutée automatiquement AVANT le constructeur (!!!)
    beforeCreate() {
        this._formManagerParent = ((this.$parent as any).formManager as HotEditableFormManager).registerField(this);
        this.$options.components = { "v-select": VueSelect };
        this.$options.template = __getHotEditableMultiSelectComponentTemplate();
    }

    created() {
    }

    mounted() {
        HotEditableHelpers.validateFieldSettings(this);

        (this.$el as Element).removeAttribute("hot-editable-cloak");

        this.updatePreviousValue();

        // permet de faire fonctionner les esc/tab/enter
        document.addEventListener("keydown", e => {
            if (!this.canChangeEditMode || !this.editModeOn)
                return;

            const isEnter = this.canChangeEditMode && this.editModeOn ? false : utilities.isEnterKeyCode(e);
            const isEscape = !isEnter && utilities.isEscapeKeyCode(e);
            const isTab = !isEnter && !isEscape && utilities.isTabKeyCode(e);

            if (isEnter || isEscape || isTab) {
                this.preventDefault(e);

                const isShifted = e.shiftKey;
                if (isShifted) {
                    if (isTab)
                        setTimeout(() => {
                            this.onShiftTabClick(e);
                        }, 1);
                } else {
                    if (isEscape)
                        this.onEscapeClick(e);
                    else if (isTab)
                        setTimeout(() => {
                            this.onTabClick(e);
                        }, 1);
                    else if (isEnter)
                        this.onEnterClick(e);
                }
            }
        });

        // permet de faire fonctionner le blur
        document.addEventListener("mousedown", e => {
            if (!this.canChangeEditMode || !this.editModeOn)
                return;

            if (utilities.isOutside(e.target as Element, this.$el))
                this.onBlur(e);
        });
    }
    updatePreviousValue(value?: any) {
        this._previousValue = value || value === "" || value === 0 || value === false
            ? value
            : this._elementValue;
        return this;
    }

    changeMode(canChangeEditMode: boolean, editModeOn: boolean) {
        this.updatePreviousValue();
        this.canChangeEditMode = canChangeEditMode;
        this.editModeOn = editModeOn;
    }

    filterBy(option: any, label: string, search: string) {
        const flatLowerLabel = ((label || "") as any).toFlatTerm() as string;
        const flatLowerSearch = ((search || "") as any).toFlatTerm() as string;
        return flatLowerLabel.indexOf(flatLowerSearch) >= 0;
    }

    setFromTextualValue(textualValue?: string) {
        if (!textualValue) {
            this.clear();
            return this;
        }

        const options = this.textualValueToOptions(textualValue);

        if (!options.length) {
            this.clear();
            return this;
        }

        if (!HotEditableMultiSelectComponent.isSameElementValue(options, this.elementValue)) {
            this.updatePreviousValue();
            this.elementValue = options;
            this._elementValue = options;
        }

        return this;
    }

    getTextualValue() {
        const t = this.optionsToTextualValue(this.elementValue);
        return t;
    }

    getDisplayedValues() {
        const l = this.getCurrentLabels();
        return l.join(", ");
    }

    onChanged(event: Event) {
        this.preventDefault(event);
        this.changed();
    }

    onCancel(event: Event) {
        this.preventDefault(event);
        this.cancel();
    }

    onClear(event: Event) {
        this.preventDefault(event);
        this.clear();
    }

    //Ne doit pas lancer des events.
    clear() {
        this.elementValue = [];
        this._elementValue = [];
        return this;
    }

    // Fonction éxécutée lorsque l'utilisateur clique sur le bouton d'édition
    editClick(event?: Event, forcedMode?: boolean) {
        if (!this.canChangeEditMode)
            return;

        this.updatePreviousValue();

        if (forcedMode === true || forcedMode === false) {
            this.editModeOn = forcedMode;
        } else {
            //toggle
            this.editModeOn = !this.editModeOn;
        }

        if (this.editModeOn) {
            //this.clearable = !!this.elementValue;//NOTE: Deja gere par le plugin

            // cas special pour le select
            this.focus();
        }

        this._formManagerParent.editModeChanged(this);
    }

    // Fonction éxécutée lorsque l'utilisateur clique sur le bouton d'annulation de l'édition
    cancel() {
        this.open(false);

        if (!this.canChangeEditMode)
            return;

        this.elementValue = this._previousValue;
        this._elementValue = this._previousValue;

        this.editModeOn = false;

        //NOTE: Le "blur()" va lancer le "changed()"
        //this.$root.$emit('hotEditableTextbox-editModeChanged', this);
    }

    // Fonction éxécutée lorsque l'utilisateur effectue un choix dans la liste déroulante (from: vue-select)
    changed() {
        this.pluginChanged(null, true);
    }

    pluginChanged(item?: any, fromChanged?: boolean) {
        fromChanged = fromChanged === true;

        if (fromChanged) {
            this.elementValue = item;
        } else {
            // Juste applique lorsque utilise depuis le vue-select original.
            this.updatePreviousValue();//@@fetetrault: en test...
            // Update hidden field for POST
            (this.$refs["hidden"] as any).value = item ? item.code : "";
        }
        this._elementValue = item;

        if (this.canChangeEditMode) {
            this.editModeOn = false;
            this._formManagerParent.editModeChanged(this);

            if (!HotEditableMultiSelectComponent.valueHasChanged(this.elementValue, this._previousValue))
                return;
        }

        this._formManagerParent.fieldChanged(this);
    }

    static valueHasChanged(current: any, previous: any) {
        if (!current && !previous)
            return false;

        if (!current || !previous)
            return true;

        return !this.isSameElementValue(current, previous);
    }

    onEnterClick(event?: KeyboardEvent) {
        // if (event && this.canChangeEditMode)
        // event.preventDefault();

        this.changed(); // pareille que le blur
    }

    onEscapeClick(event?: KeyboardEvent) {
        // if (event && this.canChangeEditMode)
        // event.preventDefault();

        this.cancel();
    }

    onTabClick(event?: KeyboardEvent) {
        //NOTE: Not used in the textbox because the tab has a builtin behavior to blur and blur() method will call the changed() method.
        this.focusNextComponent();

        // if (event && this.canChangeEditMode)
        //     event.preventDefault();
    }

    onShiftTabClick(event?: KeyboardEvent) {
        //NOTE: Not used in the textbox because the tab has a builtin behavior to blur and blur() method will call the changed() method.
        this.focusNextComponent(true);

        // if (event && this.canChangeEditMode)
        //     event.preventDefault();
    }

    private preventDefault(e?: Event, bypassStopPropagation?: boolean) {
        if (!e)
            return;

        e.preventDefault();

        if (bypassStopPropagation !== true)
            e.stopPropagation();
    }

    private focusNextComponent(getPrevious?: boolean) {
        getPrevious = getPrevious === true;

        if (!this.canChangeEditMode)
            return false;

        this.changed();
        this.editClick(null, false);

        // obligatoire car anim open/close
        setTimeout(() => {
            if (getPrevious)
                this._formManagerParent.focusPreviousComponentFromField(this)
            else
                this._formManagerParent.focusNextComponentFromField(this);
        }, 250);
    }

    onBlur(event?: Event) {
        this.blur();
    }

    blur() {
        this.changed();
        //setTimeout(() => { this.changed(true); }, 250);
    }

    focus() {
        this.open();

        this.$nextTick(() => {
            const inputEl = ((this.$refs["select"] as any).$el as Element).querySelector(".vs__search") as HTMLInputElement;

            if (inputEl)
                inputEl.focus();
            else
                utilities.printWarn("FIX ME: NE DEVRAIT PAS ETRE ICI.");
        });
    }

    open(state?: boolean) {
        state = state !== false;
        (this.$refs["select"] as any).open = state;
        return this;
    }
    private jsonValueToOptions(valueOptions: string) {
        valueOptions = valueOptions || '';
        var options = valueOptions ? JSON.parse(valueOptions) as common.IHotEditableSelectOption[] : [];
        return options;
    }
    setOptionsFromTextualValue(valueOptions: string) {
        const options = this.jsonValueToOptions(valueOptions);
        this.options = options;
        return this;
    }
    /** Permet de mettre a jour un champs frere. L'argument 'valueProcessor' permet de formatter la textualValue (null et undefined signifnient "ne pas mettre a jour"). */
    updateBrotherFromCurrentValue(brotherElementName: string, valueProcessor?: (currentValue: common.IHotEditableSelectOption[], currentTextualValue: string) => string) {
        if (!brotherElementName)
            return;
        const brother = this._formManagerParent.getFieldByName(brotherElementName);
        if (!brother)
            return;
        const currentTextualValue = this.getTextualValue();
        var textualValue: string;
        if (valueProcessor) {
            textualValue = valueProcessor(this.elementValue, currentTextualValue);
            if (!textualValue && textualValue !== '')
                return;// no update
        } else {
            textualValue = currentTextualValue;
        }
        brother.setFromTextualValue(textualValue);
    }
    private textualValueToCodes(textualValue?: string) {
        const codes = (textualValue || '').split(HotEditableMultiSelectComponent.getTextSubValueDelimiter());
        return codes;
    }

    private textualValueToOptions(textualValue?: string, options?: common.IHotEditableSelectOption[]) {
        const codes = this.textualValueToCodes(textualValue);
        return this.getOptionsByCodes(codes, options);
    }

    private optionsToTextualValue(options?: common.IHotEditableSelectOption[]) {
        options = options || [] as common.IHotEditableSelectOption[];
        const codes = [] as string[];
        for (let i = 0; i < options.length; i++) {
            const o = options[i];
            codes.push(o.code);
        }
        return codes.join(HotEditableMultiSelectComponent.getTextSubValueDelimiter());
    }
    private getOptionsByCodes(codes: string[], options?: common.IHotEditableSelectOption[]) {
        const r = [] as common.IHotEditableSelectOption[];
        for (let i = 0; i < codes.length; i++) {
            const c = codes[i];
            const o = this.getOptionByCode(c, options);
            if (o)
                r.push(o);
        }
        return r;
    }
    private getOptionByCode(code: string, options?: common.IHotEditableSelectOption[]) {
        const values = options || this.options || [];
        for (let i = 0; i < values.length; i++) {
            const o = values[i];
            if (o && o.code.trim() === code.trim())
                return o;
        }
        return null as common.IHotEditableSelectOption;
    }
    private getCurrentLabels() {
        const r = [] as string[];
        for (let i = 0; i < (this.elementValue || []).length; i++) {
            const x = this.elementValue[i];
            r.push(x.label);
        }
        return r;
    }
    private static isSameElementValue(a: any, b: any) {
        if (!a && !b)
            return true;
        const aIsNotArray = !Array.isArray(a);
        const bIsNotArray = !Array.isArray(b);
        if (aIsNotArray && bIsNotArray)
            return true;
        if (!a || !b || !aIsNotArray || !bIsNotArray)
            return false;

        a = a as common.IHotEditableSelectOption[];
        b = b as common.IHotEditableSelectOption[];
        for (let i = 0; i < a.length; i++)
            for (let j = 0; j < b.length; j++) {
                var codeA = a[i].code;
                var codeB = b[i].code;
                var labelA = a[i].label;
                var labelB = b[i].label;
                if (codeA !== codeB || labelA !== labelB)
                    return false;
            }
        return true;
    }
}

export = HotEditableMultiSelectComponent;
